import React from "react";
import TopBanner from "../components/TopBanner";
import styled from "styled-components";
import Form from "../components/Form";

const PersonalAccidentalInsurance = () => {
  return (
    <>
      <TopBanner content={"Personal Accidental Insurance"} />
      <ContentWrapper>
        <div className="text-content">
          <h2>Unexpected Accidents Deserve Unshakable Support</h2>
          <p>
            Accidents can happen anytime and the impact can be not just
            physical, but financial. Personal Accident Insurance provides a
            safety cushion by covering medical expenses, income loss, and even
            offering a payout in case of disability or accidental death.
          </p>
          <p>
            It’s an essential layer of protection for individuals, families, or
            anyone whose work involves physical risk or frequent travel.
          </p>

          <h3>What It Covers:</h3>
          <ul>
            <li>Accidental death</li>
            <li>Permanent or partial disability</li>
            <li>Temporary income loss due to injury</li>
            <li>Hospitalization and medical treatment</li>
          </ul>

          <h3>Why Personal Accident Insurance?</h3>
          <ul>
            <li>Instant financial aid in case of serious accidents</li>
            <li>Affordable premiums for large cover</li>
            <li>Helps cover bills, EMIs, and family support</li>
            <li>Available as individual or family plans</li>
          </ul>
        </div>
        <Form />
      </ContentWrapper>
    </>
  );
};

export default PersonalAccidentalInsurance;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 100px;
  gap: 20px;

  .text-content {
    width: 50%;
    p,
    ul,
    li {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #333;
      text-align: left;
    }
  }

  h3 {
    color: black;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 30px;

    .text-content {
      width: 100%;
    }
  }
`;
